import { Component, OnInit } from '@angular/core';
import { SelectPageContentSections, AuthMode, PlansData, BillData } from '../../../../shared/common/classes';
import { FormGroup } from '@angular/forms';
import { PlansManagementService } from 'src/app/shared/services/plans-management.service';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalEventsService } from '../../../../shared/services/global-events.service';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { get } from 'lodash';
import { CustomCookieService } from '../../../../shared/services/custom-cookie.service';

@Component({
  selector: 'app-review-plan',
  templateUrl: './review-plan.component.html',
  styleUrls: ['./review-plan.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class ReviewPlanComponent implements OnInit {
  public showPopOver: boolean;
  public activeSection: SelectPageContentSections = 'select-plan';
  public confirmationForm: FormGroup;
  public authMode: AuthMode;
  public preSelectedPlan: PlansData;
  public billData: BillData;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private plansManagementService: PlansManagementService,
    private globalEventsService:GlobalEventsService,
    private customCookieService: CustomCookieService
  ) { }

  ngOnInit(): void {
    this.getActiveSelectedPlan();
    this.activatedRoute.data.subscribe(({ nbs }) => {
      this.billData = nbs;
    })
  }

  public onCancelSubscriptionWithCodeConfirmation(): void {

  }

  public getActiveSelectedPlan() {
    // TODO: During refactoring need move to particular resolver
    this.plansManagementService.getActivePlan().subscribe(plan => {
      this.preSelectedPlan = plan;
    });
  }

  public onCommercialClick() {
    this.router.navigate(['select-plan'])
  }
  public onCancel() {
    const mdn = this.customCookieService.getData('ui-selectedMdn', true);
    this.router.navigate(['account/select-plan'], {
      queryParams: {mdn}
    });
  }

  public onSubscribe() {
    this.plansManagementService.subscribe().subscribe({
      next: () => {
        this.globalEventsService.notifyDataChanged('top-toast',{
          isOpen: true,
          title: `Your Subscription for ${get(this.preSelectedPlan,'displayName')} has been submitted. Activate your plan by logging into your vehicle.`,
          notFadeOut: true,
          success: true,
        });
        this.router.navigate(['/account/order-confirmation']);
      },
      error: (error) => {
        this.router.navigate(['/main/subcription-error']);
      }
    })
  }
}
